import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { Button } from "@/DesignSystem";

import styles from "./AIScribe.module.scss";

interface IAIScribeApprovedNoteWarning {
    approvedBy: string;
    approvedDate: Date;
    onCreateNewNoteClicked: () => void;
}

function AIScribeMedicalNoteApprovedPopup(props: Readonly<IAIScribeApprovedNoteWarning>): JSX.Element {
    const { getText } = useTranslation();
    const signedOffDate = LuxonDateHelper.formatToFullDateTime(props?.approvedDate) ?? "";

    function getEmployeeNameWithSuffix(): string {
        const employeeInfo = cacheStore.GetCliniciansPersonsByContactFacetId(props?.approvedBy);

        return `${employeeInfo?.prefix ?? ""} ${employeeInfo?.FirstName ?? ""} ${employeeInfo?.LastName ?? ""}`;
    }

    function handleCreateNewNoteClicked(): void {
        props.onCreateNewNoteClicked?.();
    }

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <Button
                    variant="brand"
                    label={getText("AIScribe_CreateNewNote")}
                    onClick={handleCreateNewNoteClicked}
                    size="lg"
                    id="ai-scribe-create-new-note"
                    dataCy="ai-scribe-create-new-note"
                />
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            roundTopCorner
            draggable
            disableOverlayClose
            width={465}
            title={getText("AIScribe_ApprovedNoteWarning_Title")}
            id="ai-scribe-approved-note-warning"
            dataCy="ai-scribe-approved-note-warning"
            footer={renderFooter()}
            cssClass={styles.closeWarningPopup}
        >
            <div className={styles.content}>
                <p>{`${getText("AIScribe_ApprovedNoteWarning_Message1")} ${getEmployeeNameWithSuffix()}. (${signedOffDate})`}</p>
                <p>{getText("AIScribe_ApprovedNoteWarning_Message2")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeMedicalNoteApprovedPopup };
